import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid" }
const _hoisted_2 = { class: "p-col-12 p-md-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Beden Seti Adı"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a card holder's name"
  })
], -1)
const _hoisted_4 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }
const _hoisted_5 = { class: "required" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a card holder's name"
}, null, -1)

import { defineComponent, ref, computed,h,getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";

export default /*#__PURE__*/_defineComponent({
  __name: 'AddSizeSet',
  setup(__props) {

const toast = useToast();
const sizeNameRows = ref([{ sizeName: "" }]);
const submitButton = ref<HTMLElement | null>(null);
const store = useStore();
const isActive = ref(false);
const selectedSizeSet = ref();
const sizeSetName = ref();
const toggleModal = () => {
  isActive.value = !isActive.value;
};
const saveChanges = () => {
  var model = {
    name: sizeSetName.value,
    sizeNames: sizeNameRows.value.map((f) => f.sizeName),
  };
  store.dispatch(Actions.ADD_SIZE_SET, model).then((x) => {
    if (x.success) {
      toast.add({
        severity: "success",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
      //store.dispatch(Actions.SIZE_SET_LIST)
      location.reload();
    } else {
      toast.add({
        severity: "error",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
    }
  });
};
const addExperience = (index) => {
  sizeNameRows.value.push({
    sizeName: "",
  });
 
  var i = index + 1;
  // console.log(document.getElementsByName("sizeName-" + index)[0])


  setTimeout(() => {
  document.getElementsByName("sizeName-" + (sizeNameRows.value.length - 1))[0].focus();
}, 100);
   //document.getElementsByName("sizeName-" + index+1)[0].select();  
  //document.getElementsByName("sizeName-" + index+1).focus();
};

const removeSize = (e, index) => {
  if (e.length == 0 && sizeNameRows.value.length > 1) {
    sizeNameRows.value.splice(index, 1);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-light-primary",
      onClick: toggleModal
    }, " Beden Seti Oluştur "),
    _createVNode(Modal, {
      onClose: toggleModal,
      modalActive: isActive.value,
      title: "Beden Seti Ekle",
      width: "75vw"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Kaydet",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (saveChanges())),
          icon: "pi pi-check",
          autofocus: ""
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_unref(Field), {
              type: "text",
              class: "form-control form-control-solid",
              placeholder: "",
              name: "sizeSetName",
              modelValue: sizeSetName.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sizeSetName).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizeNameRows.value, (experience, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-col-12 p-md-4",
              key: index
            }, [
              _createElementVNode("label", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _createTextVNode(" Beden "),
                  (index > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(index + 1), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_7
              ]),
              _createVNode(_unref(Field), {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Beden Adı",
                id: `sizeName[${index}]`,
                name: 'sizeName-'+index,
                ref_for: true,
                ref: `sizeName[${index}]`,
                onKeyup: [
                  _withKeys(($event: any) => (addExperience(index)), ["enter"]),
                  _withKeys(($event: any) => (removeSize(experience.sizeName, index)), ["delete"])
                ],
                modelValue: experience.sizeName,
                "onUpdate:modelValue": ($event: any) => ((experience.sizeName) = $event),
                autofocus: ""
              }, null, 8, ["id", "name", "onKeyup", "modelValue", "onUpdate:modelValue"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modalActive"])
  ], 64))
}
}

})